import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);

/* Layout */
import Layout from '../views/layout/Layout'


export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  },
  {path: '/404', component: () => import('@/views/404'), hidden: true},
 /* {path: '*', redirect: '/404', hidden: true}*/
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/order',
    component: Layout,
    redirect: '/order/public',
    name: 'order',
    meta: {title: '订单', icon: 'order',role: [1,2,3,4,5]},
    children: [
      {
        path: 'orders',
        name: 'orders',
        component: () => import('@/views/order/Orders'),
        meta: {title: '全部订单', icon: 'manage-temp',role: [3,4,5]}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/order/OrderDetail'),
        meta: {title: '订单详情',role: [3,4,5]},
        hidden:true
      },
      {
        path: 'mOrderDetail',
        name: 'mOrderDetail',
        component: () => import('@/views/order/MOrderDetail'),
        meta: {title: '订单详情',role: [1,2]},
        hidden:true
      },
      {
        path: 'public',
        name: 'public',
        component: () => import('@/views/order/Public'),
        meta: {title: '公共订单', icon: 'order-setting',role: [1,2]}
      },
      {
        path: 'mOrders',
        name: 'mOrders',
        component: () => import('@/views/order/MOrders'),
        meta: {title: '我的订单', icon: 'order-return',role: [1,2]}
      },
      {
        path: 'mOrdersp',
        name: 'mOrdersp',
        component: () => import('@/views/order/MOrdersp'),
        meta: {title: '打款信息', icon: 'order-return',role: [2]}
      },
      {
        path: 'exception',
        name: 'exception',
        component: () => import('@/views/order/Exception'),
        meta: {title: '异常订单', icon: 'order-exception',role: [3,4,5]}
      },
      {
        path: 'aDelete',
        name: 'aDelete',
        component: () => import('@/views/order/ADelete'),
        meta: {title: '已删订单', icon: 'order-delete',role: [4,5]}
      },
      {
        path: 'wSettle',
        name: 'wSettle',
        component: () => import('@/views/order/WSettle'),
        meta: {title: '野队结算', icon: 'order-settle',role: [4,5]}
      },
      {
        path: 'oRemit',
        name: 'oRemit',
        component: () => import('@/views/order/ORemit'),
        meta: {title: '野队打款', icon: 'order-remit',role: [4,5]}
      }
    ]
  },
  {
    path:'/manage',
    component: Layout,
    redirect: '/manage/booster',
    name: 'manage',
    meta: {title: '管理', icon: 'manage',role: [1,2,3,4,5]},
    children: [
      {
        path: 'booster',
        name: 'booster',
        component: () => import('@/views/manage/booster'),
        meta: {title: '代练管理', icon: 'manage-temp',role: [4,5]}
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/views/manage/customerService'),
        meta: {title: '客服管理', icon: 'manage-temp',role: [5]}
      },
      {
        path: 'game',
        name: 'game',
        component: () => import('@/views/manage/game'),
        meta: {title: '游戏管理', icon: 'manage-temp',role: [5]}
      },
   /*   {
        path: 'store',
        name: 'store',
        component: () => import('@/views/manage/store'),
        meta: {title: '店铺管理', icon: 'manage-temp',role: [5]}
      },*/
      {
        path: 'info',
        name: 'info',
        component: () => import('@/views/manage/personalInformation'),
        meta: {title: '个人资料', icon: 'manage-info',role: [1,2,3,4,5]}
      },
      {
        path: 'password',
        name: 'password',
        component: () => import('@/views/manage/changePassword'),
        meta: {title: '修改密码', icon: 'manage-password',role: [1,2,3,4,5]}
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/index.js